import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type LockboxTypeFilterOptions = {
  masterLock: boolean;
  sentriLock: boolean;
  supra: boolean;
};

const getLockboxTypeFilterOptions = async () => {
  const config: AxiosRequestConfig = {
    url: '/answering/lockbox_types',
    method: 'get',
  };

  const { data } = await axios.request<LockboxTypeFilterOptions>(config);
  return data;
};

export default getLockboxTypeFilterOptions;
